/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const BrokerR = t.interface({
  broker_code: t.string,

  description: t.string,

  enabled: t.boolean
});

// optional attributes
const BrokerO = t.partial({});

export const Broker = t.intersection([BrokerR, BrokerO], "Broker");

export type Broker = t.TypeOf<typeof Broker>;
